<app-search-ui></app-search-ui>


<nb-card id="userInfoCard" *ngIf="showSearchCard">
  <nb-card-header fxLayout="row wrap">
    <span class="h6">
      Select the destination account from below
    </span>
    <nb-form-field>
      <nb-icon nbPrefix icon="search" pack="eva"></nb-icon>
      <input type="text" nbInput (input)="searchUsers($event.target.value)">
    </nb-form-field>
  </nb-card-header>
  <nb-card-body fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="flex-start"
    *ngIf="(custDatas$ | async) as custDatas">
    <mat-card *ngFor="let item of custDatas.docs" fxFlex="0 1 calc(33.3% - 32px)" fxFlex.lt-md="0 1 calc(50% - 32px)"
      fxFlex.lt-sm="100%" class="searchResCard mat-elevation-z8" (click)="setData(item)">
      <mat-card-content>
          <nb-user size="large" name="{{item['emailId']?item['emailId']:item['mobile']}}"
            [picture]="item['profilePicUrl']" color="#cccccc" showInitials="true">
          </nb-user>
      </mat-card-content>
    </mat-card>
  </nb-card-body>
</nb-card>

<nb-card>
  <nb-card-header>
    <span class="h6">Hub Transfer</span>
  </nb-card-header>
  <nb-card-body>
    <div class="summary-container">
      <span>
        <!-- HubId -->
        <input type="text" nbInput placeholder="HubId" [(ngModel)]="fromHubId" readonly> <br>
        <br>
        <!-- <nb-checkbox (checkedChange)="markTransferAll($event)">Transfer all hubs at this place.</nb-checkbox> -->
      </span>
      <span style="margin: 8px;">
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </span>
      <span>
        <input type="email" nbInput placeholder="EmailId" [(ngModel)]="toUser" readonly>
        <button nbButton ghost status="primary" (click)="showSearchCard = !showSearchCard"><nb-icon icon="search"></nb-icon></button>
      </span>
      <span *ngIf="!isLoading">
        <button nbButton status="primary" style="margin: 4px;" (click)="transfer()" [disabled]="toUser.length == 0">Transfer</button>
      </span>
      <span *ngIf="isLoading">
        <mat-spinner></mat-spinner>
      </span>
    </div>
    <div>
      <span>
        <nb-icon icon="info-outline"></nb-icon> Make sure the hub is in a seperate place.
      </span>
      <br><span>
        <nb-icon icon="info-outline"></nb-icon> Account should exist to transfer.
      </span>
      <!-- <br><span><nb-icon icon="info-outline"></nb-icon> Make sure the hub is in a seperate place.</span> -->
    </div>
  </nb-card-body>
</nb-card>
